import React from 'react';
import Pagination from '@mui/material/Pagination';
import { bottomPaginationStyles as styles } from './bottomPagination.tailwind';
import Stack from '@mui/material/Stack';
import PaginationItem from '@mui/material/PaginationItem';
import { styled } from '@mui/material';

const BottomPagination = ({ totalPages, currentPage, onPageChange }) => {
  const CustomPagination = styled(Pagination)(() => ({
    '& .MuiPaginationItem-ellipsis': {
      color: '#FFF !important',
    },
  }));

  return (
    <div className={styles.paginationContainer}>
      <Stack spacing={2}>
        <CustomPagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page number
          onChange={onPageChange} // Function to handle page change
          variant="outlined"
          color="primary"
          shape="rounded"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              sx={{
                '&.MuiPaginationItem-root': {
                  color: 'white', 
                  borderColor: 'white', 
                  backgroundColor: item.page === currentPage ? '#020529' : '#201F3A', // Background color for the active page
                  '&:hover': {
                    backgroundColor: item.page === currentPage ? '#020529' : 'rgba(255, 255, 255, 0.08)', // Hover effect for active page and non-active pages
                  },
                }
              }}
            />
          )}
          siblingCount={1} // Number of pages shown on either side of current page
          boundaryCount={1} // Number of pages shown at start and end
        />
      </Stack>
    </div>
  );
};

export default BottomPagination;
